<template>
  <div>
    <v-select
      :value="country"
      :items="filterTariffTypes"
      :label="label"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
    >
      <template v-slot:prepend-item>
        <v-list-item class="filterBox">
          <v-list-item-content>
            <v-text-field
              v-model="filter"
              clearable
              @click:clear="filter = ''"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:selection="data">
        <div ripple class="height32">
          <div class="text-title">{{ data.item.value }}</div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.value }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TariffTypeSelect",
  props: {
    value: {
      default: false
    },
    label: {
      default: "Tariff Type"
    },
    clearable: {
      default: false
    }
  },
  mixins: [Themeable, commonMixin]
})
export default class TariffTypeSelect extends (Vue, Themeable) {
  tariffType = null;
  tariffTypes = [];
  loading = true;
  filter = "";

  get filterTariffTypes() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.tariffTypes;
    const fc = this.tariffTypes.filter(function(c) {
      return c.value.toLowerCase().indexOf(filterby) >= 0;
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.tariffType = newVal;
    if (newVal && newVal.name) {
      this.$emit("input", newVal.name);
      return;
    }
    if (!newVal) this.$emit("input", null);
  }

  setDefault() {
    if (this.value) {
      for (let i = 0; i < this.tariffTypes.length; i++) {
        if (this.tariffTypes[i].key === this.value) {
          this.tariffType = this.tariffTypes[i];
          break;
        }
      }
    }
  }

  async mounted() {
    await common.populateTariffTypes();
    this.tariffTypes = common.tariffTypes;
    this.setDefault();
    this.loading = false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "" || this.value == null) {
      this.tariffType = null;
    }
    this.setDefault();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
